<template>
  <span>
    <q-btn
      v-if="isGranted('VIEW_USER_INVITATION_LINK')"
      icon="fa fa-link"
      label="Copy Invite Link"
      color="red"
      :loading="isLoading"
      @click="fetchLink"
    />
    <Modal ref="modal" title="Invitation Link" size="xs">
      <message class="text-center q-my-sm">
          Click the link below to copy it to your clipboard:
      </message>
      <div class="q-pa-sm bg-grey-3 rounded-borders">
        <a
          href="#"
          class="invitation-link text-primary"
          @click.prevent="copyLink"
        >{{ invitationUrl }}</a>
      </div>
      <template #actions>
        <q-btn color="primary" label="Copy" @click="copyLink" />
      </template>
    </Modal>
  </span>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { copyToClipboard } from 'quasar';
import { HasTaskMixin } from '@/mixins';
import notify from '@/components/notify';
import isGranted from '@/auth/isGranted';
import Modal from '@/components/modal/Modal.vue';
import Message from '@/components/message/Message.vue';
import { generateInvitationLink } from './user';

interface Data {
  task: Promise<{ url: string }>|null,
  invitationUrl: string,
  isLoading: boolean,
}

export default defineComponent({
  mixins: [HasTaskMixin],
  components: {
    Modal,
    Message,
  },
  props: {
    userId: {
      type: Number,
      required: true,
    },
  },
  data(): Data {
    return {
      task: null,
      invitationUrl: '',
      isLoading: false,
    };
  },
  methods: {
    isGranted,
    fetchLink() {
      this.task = generateInvitationLink(this.userId);
      this.task.then(({ url }) => {
        this.invitationUrl = url;
        (this.$refs.modal as any).show();
      });
    },
    copyLink() {
      copyToClipboard(this.invitationUrl)
        .then(() => {
          notify('Invitation link copied to clipboard.');
          (this.$refs.modal as any).hide();
        });
    },
  },
});
</script>

<style scoped>
.invitation-link {
  word-break: break-all;
  cursor: pointer;
  text-decoration: none;
}
</style>
